// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  TimeRecordFilter,
  getTimeRecords,
  serializeTimeRecordFilter,
} from '@/costs/api/get-time-records';
import { useSuspenseQuery } from '@tanstack/react-query';

interface UseTimeRecordsOptions {
  filter?: TimeRecordFilter;
}

/**
 * Hook to fetch and manage time records data
 *
 * @param options Optional filter parameters
 * @returns An object containing the time records array, total count, and loading states
 */
export function useTimeRecords(options: UseTimeRecordsOptions = {}) {
  const filter = options.filter ?? { pageSize: 50 };
  const serializedFilter = serializeTimeRecordFilter(filter);

  const { data, isFetching } = useSuspenseQuery({
    queryKey: ['time-records', serializedFilter],
    queryFn: () => getTimeRecords(filter),
  });

  return {
    timeRecords: data.results,
    totalCount: data.totalCount,
    isFetching,
  };
}
